import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from "./site/header/header";
import { Footer } from "./site/footer/footer";
import { ThemeService } from "./_services";

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, Header, Footer],
})
export class App {
  protected readonly title = signal('Lakeshore Landing');

  constructor(themeService: ThemeService) {
    themeService.loadSavedTheme();
  }
}
